import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4c226309&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c226309')) {
      api.createRecord('4c226309', component.options)
    } else {
      api.reload('4c226309', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=4c226309&", function () {
      api.rerender('4c226309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/Detail/Loader.vue"
export default component.exports